module.exports = __webpack_public_path__ + "img/fondo-login-mobile2.fb6ca3df.png";